export default "__VITE_ASSET__Ba8v3PeM__"